import { IApplicationState } from '../../types/redux';
export const selectPikPromoBanner = (state: IApplicationState) => {
  return state.pikPromoBanner;
};
